import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  CssBaseline,
  Grid,
  Menu,
  MenuItem,
  Modal,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { DataGrid, esES } from "@mui/x-data-grid";
import Topbar from "../../../../components/topbar/TopBar";
import Header from "../../../../components/header/Header";
import { tokens } from "../../../../theme";
import { TableStyle } from "../components/TableStyle";
import { ReadScheduledUseCase } from "../../../domain/usecases/schedule/ReadScheduledUseCase";
import { ReadSubscribedByIdUseCase } from "../../../domain/usecases/schedule/ReadSubscribedByIdUseCase";
import CancelPresentationOutlinedIcon from "@mui/icons-material/CancelPresentationOutlined";
import { ReadScheduledManifest } from "../../../data/repository/manifest.repo";
import {
  getTokenRefresh,
  verifyExpireTokenRefresh,
} from "../../../../helpers/token/refreshToken";
import { getDriverAndVehicle } from "../../../../api/users/driver/driver";
import { AssignScheduledUseCase } from "../../../domain/usecases/schedule/AssignScheduledUseCase";
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { dateFormat, timeFormat } from "../../../../helpers/date/date";
import { RescheduleUseCase } from "../../../domain/usecases/schedule/RescheduleUseCase";
import { LinkPayScheduleUseCase } from "../../../domain/usecases/schedule/LinkPayScheduleUseCase";
import { DeleteScheduleUseCase } from "../../../domain/usecases/schedule/DeleteScheduleUseCase";

export const ScheduledListScreen = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [scheduled, setScheduled] = useState([]);
  const [idScheduled, setIdScheduled] = useState(0);

  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [linkPen, setLinkPen] = useState(null);
  const [linkUsd, setLinkUsd] = useState(null);

  useEffect(() => {
    const scheduledList = async () => {
      const resp = await ReadScheduledUseCase();
      console.log(resp);
      if (resp.message === "success") {
        setScheduled(resp.schedule);
      }
    };
    scheduledList();
  }, []);

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const [scheduleId, setScheduleId] = useState(0);
  const columns = [
    {
      headerName: "TITULO",
      field: "tour_title",
      type: "number",
      headerAlign: "left",
      align: "left",
      width: 150,
      renderCell: ({ row: { tour_code, tour_title } }) => {
        return (
          <div>
            <p>{tour_code}</p>
            <p>{tour_title}</p>
          </div>
        );
      },
    },
    {
      headerName: "PAIS",
      field: "country_name",
      type: "string",
      width: 100,
      renderCell: ({ row: { country_name, city_name } }) => {
        return (
          <div>
            <p>{country_name}</p>
            <p>{city_name}</p>
          </div>
        );
      },
    },
    {
      headerName: "FECHA",
      headerAlign: "left",
      field: "date",
      width: 100,
      renderCell: ({ row: { date, time } }) => {
        return (
          <div>
            <p>{date}</p>
            <p>{time}</p>
          </div>
        );
      },
    },
    {
      headerName: "ORIGEN",
      field: "origin",
      type: "string",
      headerAlign: "left",
      align: "left",
      width: 230,
      renderCell: ({ row: { origin, destination } }) => {
        return (
          <div>
            <p>{origin}</p>
            <p>{destination}</p>
          </div>
        );
      },
    },
    {
      headerName: "Cantidad",
      field: "capacity_total",
      width: 60,
    },
    {
      headerName: "Ocupado",
      field: "capacity",
      width: 60,
      renderCell: ({ row: { capacity_total, capacity } }) => {
        return (
          <div>
            <p>{capacity_total - capacity}</p>
          </div>
        );
      },
    },
    {
      headerName: "Conductor",
      field: "driver_name",
      width: 200,
      renderCell: ({ row: { driver_name, driver_lastname } }) => {
        return (
          <div>
            <p>{driver_name}</p>
            <p>{driver_lastname}</p>
            {/* <p>{vehicle_plate}</p> */}
          </div>
        );
      },
    },
    {
      headerName: "PLACA",
      field: "vehicle_plate",
      width: 70,
    },
    {
      headerName: "Nota",
      field: "note",
      width: 220,
    },
    {
      headerName: "",
      field: "actions",
      headerAlign: "center",
      width: 180,
      align: "center",
      renderCell: ({ row: { id, date, time, link_pay_pen, link_pay_usd } }) => {
        return (
          <Stack direction="row" spacing={1}>
            <Button
              aria-controls={openMenu ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openMenu ? "true" : undefined}
              variant="contained"
              color="success"
              onClick={(e) => {
                setScheduleId(id);
                handleClick(e);
              }}
              sx={{ color: "white" }}
            >
              OPCIONES
            </Button>

            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleClose}
              MenuListProps={{ "aria-labelledby": "basic-button" }}
            >
              <MenuItem
                onClick={async (e) => {
                  handleClose();
                  await getSubscribedsById(scheduleId);
                  handleClientOpen();
                }}
              >
                LISTA CLIENTES
              </MenuItem>
              <MenuItem
                onClick={async (e) => {
                  handleClose();
                  console.log(id);
                  handleManifestOpen();
                  getScheduledManifest(id);
                }}
              >
                MANIFIESTO
              </MenuItem>
              <MenuItem
                onClick={async (e) => {
                  handleClose();
                  console.log(id);
                  setIdScheduled(id);
                  handleDriverOpen();
                }}
              >
                CONDUCTOR
              </MenuItem>
              <MenuItem
                onClick={async (e) => {
                  handleClose();
                  console.log(id);
                  setIdScheduled(id);
                  handleRescheduleOpen();
                }}
              >
                REPROGRAMAR
              </MenuItem>
              <MenuItem
                onClick={async (e) => {
                  handleClose();
                  setIdScheduled(id);
                  setLinkPen(link_pay_pen);
                  setLinkUsd(link_pay_usd);
                  handleLinkPayOpen();
                }}
              >
                LINK PAGO
              </MenuItem>

              <MenuItem
                onClick={async (e) => {
                  handleClose();
                  setIdScheduled(id);
                  handleDeleteOpen();
                }}
              >
                ELIMINAR
              </MenuItem>
            </Menu>
          </Stack>
        );
      },
    },
  ];

  const clientCol = [
    {
      headerName: "CLIENTE",
      field: "rider_name",
      width: 190,
      renderCell: ({ row: { rider_name, rider_lastname, rider_phone } }) => {
        return (
          <div>
            <p>
              {rider_name} {rider_lastname}
            </p>
            <p>{rider_phone}</p>
          </div>
        );
      },
    },
    {
      headerName: "EMAIL",
      field: "rider_email",
      width: 160,
    },
    {
      headerName: "Personas",
      field: "persons",
      width: 70,
      align: "center",
    },
    {
      headerName: "Precio",
      field: "price",
      width: 70,
      align: "center",
    },
    {
      headerName: "Adelanto",
      field: "advance",
      width: 70,
      align: "center",
      renderCell: ({ row: { advance } }) => {
        let amount = 0;
        advance.map((item) => {
          amount += Number(item.amount);
          return amount;
        });
        return <p>{amount}</p>;
      },
    },
    {
      headerName: "Nota",
      field: "note",
      width: 200,
    },
    {
      headerName: "OPCIONES",
      field: "actions",
      headerAlign: "center",
      width: 150,
      align: "center",
      renderCell: ({ row: { id } }) => {
        return (
          <Stack
            direction="row"
            spacing={1}
            style={{
              display: "flex",
              alignContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <p>Manifiesto</p>
            <CancelPresentationOutlinedIcon
              sx={{ color: "red", cursor: "pointer" }}
              onClick={(e) => alert("cancel")}
            />
          </Stack>
        );
      },
    },
  ];

  const manifestCol = [
    {
      headerName: "CLIENTE",
      field: "name",
      width: 250,
    },
    {
      headerName: "PAIS",
      field: "country",
      width: 100,
    },
    {
      headerName: "DOCUMENTO",
      field: "document",
      width: 120,
    },
    {
      headerName: "EDAD",
      field: "age",
      width: 50,
      align: "center",
    },
    {
      headerName: "Telefono",
      field: "phone",
      width: 150,
    },
  ];

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    height: "90vh",
    bgcolor: "background.paper",
    border: "1px solid #000",
    borderRadius: "15px",
    p: 2,
  };
  const [openClients, setOpenClients] = useState(false);
  const handleClientOpen = () => setOpenClients(true);
  const handleClientClose = () => setOpenClients(false);
  const [clientList, setClientList] = useState([]);

  const [openManifest, setOpenManifest] = useState(false);
  const handleManifestOpen = () => setOpenManifest(true);
  const handleManifestClose = () => setOpenManifest(false);
  const [manifestList, setManifestList] = useState([]);

  const getSubscribedsById = async (id) => {
    const resp = await ReadSubscribedByIdUseCase(id);
    if (resp.message === "success") {
      setClientList(resp.data);
    }
  };

  const getScheduledManifest = async (id) => {
    const resp = await ReadScheduledManifest(id);
    if (resp.data.message === "success") {
      setManifestList(resp.data.data);
    }
  };

  const assignScheduledDriver = async (id, driverData) => {
    console.log(id, driverData);
    const scheduled = {
      driverId: driverData.driver_id,
      vehicleId: driverData.vehicle_id,
      scheduledId: id,
    };
    const resp = await AssignScheduledUseCase(scheduled);
    handleDriverClose();
  };

  const rescheduleDate = async (id) => {
    const scheduled = {
      scheduledId: id,
      date: dateFormat(date.$d),
      time: timeFormat(time.$d),
    };
    console.log(scheduled);
    await RescheduleUseCase(scheduled);
    handleRescheduleClose();
  };

  const linkPaySchedule = async (id) => {
    const scheduled = {
      scheduledId: id,
      linkPen: linkPen,
      linkUsd: linkUsd,
    };
    console.log(scheduled);
    await LinkPayScheduleUseCase(scheduled);
    handleRescheduleClose();
  };

  const deleteSchedule = async (id) => {
    const scheduled = {
      scheduledId: id,
    };
    console.log(scheduled);
    await DeleteScheduleUseCase(scheduled);
    handleRescheduleClose();
  };

  const [openDriver, setOpenDriver] = useState(false);
  const handleDriverOpen = () => setOpenDriver(true);
  const handleDriverClose = () => setOpenDriver(false);
  const [drivers, setDrivers] = useState(null);
  const [driver, setDriver] = useState(null);

  const [reschedule, setReschedule] = useState(false);
  const handleRescheduleOpen = () => setReschedule(true);
  const handleRescheduleClose = () => setReschedule(false);

  const [linkPayModal, setLinkPayModal] = useState(false);
  const handleLinkPayOpen = () => setLinkPayModal(true);
  const handleLinkPayClose = () => setLinkPayModal(false);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteOpen = () => setDeleteModal(true);
  const handleDeleteClose = () => setDeleteModal(false);

  useEffect(() => {
    const driversData = async () => {
      const verify = verifyExpireTokenRefresh();
      if (verify) return console.log("no token");

      const token = getTokenRefresh();
      try {
        const response = await getDriverAndVehicle(token);
        setDrivers(response?.data);
      } catch (error) {
        console.log(error);
      }
    };
    driversData();
  }, []);

  return (
    <>
      <CssBaseline />
      <div className="app">
        <main className="content">
          <Topbar />
          <Box m="10px">
            <Box display="flex" justifyContent="space-between">
              <Header title={"LISTA TOURS PROGRAMADOS"} subtitle="" />
            </Box>
            <Box gap="10px">
              <Box>
                <Box m="10px 0 0 0" height="100vh" sx={TableStyle(colors)}>
                  <DataGrid
                    getRowId={(row) => row.id}
                    rows={scheduled}
                    columns={columns}
                    localeText={
                      esES.components.MuiDataGrid.defaultProps.localeText
                    }
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </main>
      </div>

      {/* LISTA DE CLIENTES */}
      <Modal
        open={openClients}
        onClose={handleClientClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              LISTA DE CLIENTES
            </Typography>
            {/* <Button color="success">PDF</Button> */}
          </div>

          <DataGrid
            sx={{ height: "80vh" }}
            getRowId={(row) => row.id}
            rows={clientList}
            columns={clientCol}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          />
        </Box>
      </Modal>
      {/* LISTA DE MANIFIESTO */}
      <Modal
        open={openManifest}
        onClose={handleManifestClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              LISTA DE CLIENTES
            </Typography>
            {/* <Button color="success">PDF</Button> */}
          </div>

          <DataGrid
            sx={{ height: "80vh" }}
            getRowId={(row) => row.id}
            rows={manifestList}
            columns={manifestCol}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          />
        </Box>
      </Modal>
      <Modal
        open={openDriver}
        onClose={handleDriverClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, height: "35vh", width: { sm: "60%", xs: "90%" } }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              LISTA DE CONDUCTORES
            </Typography>
            {/* <Button color="success">PDF</Button> */}
          </div>
          <div
            style={{
              marginTop: "10px",
            }}
          >
            <Autocomplete
              value={driver}
              disablePortal
              name="driver"
              id="combo-box-driver"
              onChange={(e, newValue) => {
                setDriver(newValue);
              }}
              options={drivers}
              getOptionLabel={(option) =>
                `${option.driver_id}: ${option.name} ${option.lastname} - ${option.brand} ${option.model} ${option.bodywork} ${option.plate} ${option.color}`
              }
              renderInput={(params) => (
                <TextField {...params} label={"Condutorer"} />
              )}
            />

            <Button
              variant="contained"
              color="success"
              fullWidth
              style={{
                padding: 5,
                marginTop: 5,
                height: "40px",
                color: "white",
                fontWeight: "bold",
              }}
              onClick={(e) => {
                e.preventDefault();
                console.log(driver);
                assignScheduledDriver(idScheduled, driver);
              }}
            >
              Asignar
            </Button>
          </div>
        </Box>
      </Modal>

      {/* REPROGRAMAR */}
      <Modal open={reschedule} onClose={handleRescheduleClose}>
        <Box sx={{ ...style, height: "35vh", width: { sm: "60%", xs: "90%" } }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              REPROGRAMAR FECHA DEL TOUR
            </Typography>
            {/* <Button color="success">PDF</Button> */}
          </div>

          <Grid container spacing={1.5} sx={{ alignItems: "center" }}>
            <Grid item xs={6} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={2}>
                  <MobileDatePicker
                    label={"FECHA"}
                    inputFormat="DD/MM/YYYY"
                    name="date"
                    value={date}
                    onChange={(newValue) => {
                      setDate(newValue);
                      // setDateFormat(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Stack>
              </LocalizationProvider>
            </Grid>

            <Grid item xs={6} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={3}>
                  <MobileTimePicker
                    label={"HORA"}
                    value={time}
                    name="time"
                    onChange={(newValue) => {
                      setTime(newValue);
                      // setTimeFormat(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Stack>
              </LocalizationProvider>
            </Grid>
          </Grid>

          <div
            style={{
              marginTop: "10px",
            }}
          >
            <Button
              variant="contained"
              color="success"
              fullWidth
              style={{
                padding: 5,
                marginTop: 5,
                height: "40px",
                color: "white",
                fontWeight: "bold",
              }}
              onClick={(e) => {
                e.preventDefault();
                rescheduleDate(idScheduled);
              }}
            >
              ACTUALIZAR
            </Button>
          </div>
        </Box>
      </Modal>

      {/* LINK PAGO */}
      <Modal open={linkPayModal} onClose={handleLinkPayClose}>
        <Box
          sx={{
            ...style,
            height: { sm: "35vh", xs: "45vh" },
            width: { sm: "60%", xs: "90%" },
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              ACTUALIZAR LINK DE PAGO
            </Typography>
            {/* <Button color="success">PDF</Button> */}
          </div>

          <Grid container spacing={1.5} sx={{ alignItems: "center" }}>
            <Grid item xs={12} sm={6}>
              <TextField
                value={linkPen}
                fullWidth
                type="text"
                label={"LINK PEN"}
                onChange={(e) => {
                  e.preventDefault();
                  setLinkPen(e.target.value);
                }}
                name="linkPen"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                value={linkUsd}
                fullWidth
                type="text"
                label={"LINK USA"}
                onChange={(e) => {
                  e.preventDefault();
                  setLinkUsd(e.target.value);
                }}
                name="linkUsd"
              />
            </Grid>
          </Grid>

          <div
            style={{
              marginTop: "10px",
            }}
          >
            <Button
              variant="contained"
              color="success"
              fullWidth
              style={{
                padding: 5,
                marginTop: 5,
                height: "40px",
                color: "white",
                fontWeight: "bold",
              }}
              onClick={(e) => {
                e.preventDefault();
                linkPaySchedule(idScheduled);
              }}
            >
              ACTUALIZAR
            </Button>
          </div>
        </Box>
      </Modal>
      {/* ELIMINAR */}
      <Modal open={deleteModal} onClose={handleDeleteClose}>
        <Box
          sx={{
            ...style,
            height: { sm: "25vh", xs: "30vh" },
            width: { sm: "50%", xs: "90%" },
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              DESEA ELIMINAR ESTE TOUR?
            </Typography>
          </div>

          <div
            style={{
              marginTop: "10px",
            }}
          >
            <Button
              variant="contained"
              color="error"
              fullWidth
              style={{
                padding: 5,
                marginTop: 5,
                height: "40px",
                color: "white",
                fontWeight: "bold",
              }}
              onClick={(e) => {
                e.preventDefault();
                deleteSchedule(idScheduled);
              }}
            >
              ELIMINAR
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};
